// Défini dans .env (NEXT_PUBLIC_APP_ENV=dev|prod). Défaut : prod.
export const IS_DEV = process.env.NEXT_PUBLIC_APP_ENV === "dev";

export const BASE_URL = IS_DEV ? "http://vieillir.test/" : "https://vieillir.ca/";
export const DOMAINE_NAME = IS_DEV
  ? "http://admin.vieillir.test/admin"
  : "https://admin.vieillir.ca/admin";
